/* eslint-disable camelcase */
import { ptBr_analyticTitle } from './analytic/title';
import { ptBR_globalTips } from './global/title';

const pt_BR = {
  ...ptBR_globalTips,
  ...ptBr_analyticTitle,
};

export default pt_BR;
